import $ from 'jquery';

// Import utilities and components
const { addParametersToURL } = _uo.utility;
import { openInNewTab, addUTMParameters, restCall } from '@builder/common/utilities';
import { isAutomatorProActive } from '@builder/utilities';

// Import utilities
const {
	isDefined
} = _uo.utility;

import { canManageSchedule } from '@builder/item/schedule/utilities';

import Field from '../field';

import Modal from '../common/modal.js';

import Actions from './actions.js';

class ItemHeaderAsync {
	buttonContainer;

	button;

	buttonIcon;

	removeButton;

	asyncModeField;

	asyncModeHTML;

	delayNumberField;

	delayNumberHTML;

	delayUnitField;

	delayUnitHTML;

	scheduleDateField;

	scheduleDateHTML;

	scheduleTimeField;

	scheduleTimeHTML;

	scheduleNoticeHTML;

	modal;

	/**
	 * Create item actions
	 *
	 * @since 0.5
	 * @return jQuery DOM element with the item actions
	 */

	constructor( itemType, integrationID, itemCode, itemId ) {
		this.itemType = itemType;
		this.integrationID = integrationID;
		this.itemCode = itemCode;
		this.itemId = itemId;
		this.item = UncannyAutomator.recipe.items[ itemId ];
		this.asyncMode = this.item.meta.async_mode;

		if ( UncannyAutomator.proVersion.startsWith( '2' ) ) {
			return null;
		}

		this.createAsyncButton();
	}

	hasSchedule() {
		if ( ! this.asyncMode ) {
			return false;
		}

		if ( this.asyncMode == 'delay' ) {
			return this.item.meta.async_delay_number && this.item.meta.async_delay_unit;
		}

		if ( this.asyncMode == 'schedule' ) {
			return this.item.meta.async_schedule_time && this.item.meta.async_schedule_date;
		}

		return false;
	}

	getButtonText() {
		if ( this.hasSchedule() ) {
			let text = UncannyAutomator.i18n.action.asyncActions[ this.asyncMode ];
			text += ' ';

			if ( isAutomatorProActive() ) {
				text += `${ this.item.meta.async_sentence }`;
			} else {
				text += `<strike>${ this.item.meta.async_sentence }</strike>`;
			}

			return text;
		}
		
		return UncannyAutomator.i18n.action.asyncActions.delay;
	}

	createAsyncButton() {
		// Create wrapper
		this.buttonContainer = document.createElement( 'div' );
		this.buttonContainer.classList.add( 'item-async' );

		// Create button
		this.buttonContainer.innerHTML = `
			<uo-button
				size="extra-small"
				color="secondary"
			>
				<uo-icon id="clock"></uo-icon> ${ this.getButtonText() }
			</uo-button>
		`;

		this.buttonContainer = $( this.buttonContainer );
		this.button = this.buttonContainer.find( 'uo-button' );

		if ( canManageSchedule() ) { 

			if ( this.hasSchedule() ) {
				this.createRemoveButton();
			}

			// Listen clicks to the open button
			this.button.on( 'click', () => {
				if ( ! this.buttonContainer.hasClass( 'disabled' ) ) {
					this.showModal();
				}
			} );

			this.buttonContainer.on( 'automator:asyncButton:maybeDisable', ( e, disable ) => {
				const buttonContainer = $( e.currentTarget );

				if ( disable ) {
					buttonContainer.attr( 'uap-tooltip', UncannyAutomator.i18n.action.asyncActions.pleaseSave );

					this.button.prop( 'disabled', true );
				} else {
					this.button.prop( 'disabled', false );
					buttonContainer.removeAttr( 'uap-tooltip', false );
				}
			} );

		} else {
			// Disable the button
			this.button.get(0)
				.setAttribute( 'disabled', '' );

			// Add tooltip
			this.buttonContainer.get(0)
				.setAttribute( 'uap-tooltip', UncannyAutomator.i18n.action.asyncActions.unlockSchedule );

			// Open link on click
			this.buttonContainer.get(0).addEventListener( 'click', () => {
				// Open URL on a new tab
				openInNewTab(
					addParametersToURL(
						// Add UTM parameters
						addUTMParameters( 'https://automatorplugin.com/pricing/', {
							medium: 'recipe_creator',
							content: 'action_disabled_schedule_button',
						} ),
						{
							uap_bpro_context: 'delay'
						}
					)
				);
			} );
		}

		this.$button = this.buttonContainer.get(0);
	}

	enable() {
		this.button.removeAttr( 'uap-tooltip' );
		this.button.removeAttr( 'disabled' );
	}

	createRemoveButton() {
		this.removeButton = $( '<span/>', { class: 'async-remove' } );
		this.removeButtonIcon = $( '<uo-icon/>', { id: 'times' } );

		this.removeButton.text( UncannyAutomator.i18n.action.asyncActions.remove );
		this.removeButton.on( 'click', () => {
			this.removeSchedule();
		} );
		this.removeButton.prepend( this.removeButtonIcon );
		this.buttonContainer.append( this.removeButton );
	}

	createModalContent() {
		// Create the content for the modal
		const modalContent = $( `<div/>`, { class: 'async-action-modal' } );

		this.asyncModeHTML = this.createAsyncModeHTML();

		this.asyncModeHTML.find( '.form-radio__container:first' ).after( this.createDelayOptions() );
		this.asyncModeHTML.find( '.form-radio__container:last' ).after( this.createScheduleOptions() );

		this.attachModeChangeEvent();

		// Add the field
		modalContent.append( this.asyncModeHTML );

		if ( this.hasSchedule() ) {
			const modalNoticeHTML = $( '<div/>', { class: 'async-notice async-notice__blue' } );
			const modalNoticeIcon = $( '<uo-icon/>', { id: 'exclamation-triangle' } );
			modalNoticeHTML.append( modalNoticeIcon );
			modalNoticeHTML.append( UncannyAutomator.i18n.action.asyncActions.modal.scheduleNotice2 );
			modalContent.append( modalNoticeHTML );
		}

		return modalContent;
	}

	showModal() {
		let confirmButtonText = UncannyAutomator.i18n.action.asyncActions.modal.confirm;

		if ( this.hasSchedule() && this.asyncMode == 'schedule' ) {
			confirmButtonText = UncannyAutomator.i18n.action.asyncActions.schedule;
		}

		// Show a modal
		this.modal = new Modal(
			{
				title: UncannyAutomator.i18n.action.asyncActions.modal.title,
				content: this.createModalContent(),
				buttons: {
					cancel: UncannyAutomator.i18n.cancel,
					confirm: confirmButtonText,
				},
			},
			{
				size: 'large',
				customClass: 'async-action',
			}
		);

		this.modalEvents();
	}

	modalEvents() {
		this.modal.setEvents( {
			afterSetEvents: () => {
				this.modal.show();
			},
			onConfirm: () => {
				this.submitModal();
			},
			afterHide: () => {
				this.modal.destroy();
			},
		} );
	}

	submitModal() {
		const elements = this.modal.getElements();
		const confirmButton = elements.modal.box.buttons.confirm;

		// Add loading class to button
		confirmButton.addClass( 'uap-btn--loading' ).prop( 'disabled', true );

		if ( ! this.validateForm().isValid ) {
			confirmButton.removeClass( 'uap-btn--loading' ).prop( 'disabled', false );
			return;
		}

		const asyncMode = this.asyncModeField.getValue();
		const delayNumber = this.delayNumberField.getValue();
		const delayUnit = this.delayUnitField.getValue();
		const scheduleTime = this.scheduleTimeField.getValue();
		const scheduleDate = this.scheduleDateField.getValue();

		let sentence;

		if ( asyncMode == 'delay' ) {
			sentence = this.delaySentence();
		} else {
			sentence = this.scheduleSentence();
		}

		this.saveSchedule( asyncMode, delayNumber, delayUnit, scheduleTime, scheduleDate, sentence );
	}

	delaySeconds() {
		const delayUnit = this.delayUnitField.getValue();
		const delayNumber = this.delayNumberField.getValue();
		let multiplier;

		switch ( delayUnit ) {
			case 'seconds':
				multiplier = 1;
				break;
			case 'minutes':
				multiplier = 60;
				break;
			case 'hours':
				multiplier = 60 * 60;
				break;
			case 'days':
				multiplier = 60 * 60 * 24;
				break;
			case 'years':
				multiplier = 60 * 60 * 24 * 365;
				break;
			default:
				multiplier = 1;
				break;
		}

		return delayNumber * multiplier;
	}

	delaySentence() {
		let unit = this.delayUnitField.getValue();

		if ( this.delayNumberField.getValue() == 1 ) {
			unit = unit.slice( 0, -1 );
		}

		return `${ this.delayNumberField.getValue() } ${ UncannyAutomator.i18n.action.asyncActions.modal[
			unit
		].toLowerCase() }`;
	}

	scheduleSeconds() {
		return Date.parse( `${ this.scheduleDateField.getValue() } ${ this.scheduleTimeField.getValue() }` );
	}

	scheduleSentence() {
		return `${ this.scheduleDateField.getValue() } @ ${ this.scheduleTimeField.getValue() }`;
	}

	saveSchedule(
		asyncMode,
		delayNumber = null,
		delayUnit = null,
		scheduleTime = null,
		scheduleDate = null,
		sentence = null
	) {
		// Do call and hide
		restCall(
			'schedule_action',
			{
				recipeId: UncannyAutomator.recipe.id,
				actionId: this.itemId,
				asyncMode: asyncMode,
				delayNumber: delayNumber,
				delayUnit: delayUnit,
				scheduleTime: scheduleTime,
				scheduleDate: scheduleDate,
				scheduleSentence: sentence,
			},
			() => {
				// Destroy modal
				this.modal.destroy();

				// Clear the cache of tokens
				UncannyAutomator.cache.tokens = [];

				new Actions();

				// Check if the recipe is still valid, if it isn't then make the recipe draft
				if ( ! UncannyAutomator.recipe.isValid ) {
					UncannyAutomator.recipe.publish.statusToggle.setValue( false );
				}
			},
			() => {
				// Destroy modal
				this.modal.destroy();

				console.log( "‼️ ERROR-TODO. Couldn't schedule the item" );

				new Actions();
			}
		);
	}

	removeSchedule() {
		// Do call and hide
		restCall(
			'remove_schedule',
			{
				recipeId: UncannyAutomator.recipe.id,
				actionId: this.itemId,
			},
			() => {
				// Clear the cache of tokens
				UncannyAutomator.cache.tokens = [];

				new Actions();

				// Check if the recipe is still valid, if it isn't then make the recipe draft
				if ( ! UncannyAutomator.recipe.isValid ) {
					UncannyAutomator.recipe.publish.statusToggle.setValue( false );
				}
			},
			() => {
				console.log( "‼️ ERROR-TODO. Couldn't schedule the item" );

				new Actions();
			}
		);
	}

	createTimeZone() {
		const timeZoneLink = $( '<a/>', {
			href: UncannyAutomator.i18n.action.asyncActions.modal.timezoneLink,
			target: '_blank',
		} );

		const timeZoneHelpIcon = $( '<uo-icon/>', { id: 'question-circle' } );

		const timeZoneDesc = $( '<span/>', { class: 'schedule-fields__description' } ).html(
			`<strong>${ UncannyAutomator.i18n.action.asyncActions.modal.timezone }</strong>: ${ UncannyAutomator.i18n.action.asyncActions.modal.timezoneString }`
		);

		timeZoneLink.append( timeZoneHelpIcon );

		timeZoneDesc.append( timeZoneLink );

		return timeZoneDesc;
	}

	createAsyncModeHTML() {
		// Create the radio field
		this.asyncModeField = new Field( 'radio', {
			itemType: 'action',
			optionCode: 'schedule_type',
			name: 'schedule-type',
			isRequired: true,
			currentValue: this.asyncMode ? this.asyncMode : 'delay',
			options: [
				{
					value: 'delay',
					text: UncannyAutomator.i18n.action.asyncActions.delay,
				},
				{
					value: 'schedule',
					text: UncannyAutomator.i18n.action.asyncActions.schedule,
				},
			],
		} );

		return this.asyncModeField.createFormElement().addClass( 'schedule-type-radio' );
	}

	attachModeChangeEvent() {
		// Attach an event and change the confirm button text according to selection
		this.asyncModeHTML.on( 'automator:field:change', () => {
			const selectedAsyncMode = this.asyncModeField.getValue();
			let text, showNotice;

			if ( selectedAsyncMode == 'schedule' ) {
				text = UncannyAutomator.i18n.action.asyncActions.schedule;
			} else {
				text = UncannyAutomator.i18n.action.asyncActions.modal.confirm;
			}

			if ( ! this.hasSchedule() ) {
				if ( selectedAsyncMode == 'schedule' ) {
					this.scheduleNoticeHTML.removeClass( 'hidden' );
				} else {
					this.scheduleNoticeHTML.addClass( 'hidden' );
				}
			}

			this.modal.elements.modal.box.buttons.confirm.text( text );
		} );
	}

	createScheduleOptions() {
		const scheduleOptions = $( `<div/>`, { class: 'schedule-options' } );

		const scheduleDesc = $( '<span/>', { class: 'async-mode__description' } ).text(
			UncannyAutomator.i18n.action.asyncActions.modal.scheduleDesc
		);

		const scheduleFields = $( '<div/>', { class: 'schedule-fields' } );

		if ( ! this.hasSchedule() ) {
			this.scheduleNoticeHTML = $( '<div/>', { class: 'schedule-notice hidden' } );
			this.scheduleNoticeHTML.text( UncannyAutomator.i18n.action.asyncActions.modal.scheduleNotice1 );

			this.scheduleNoticeHTML.addClass( 'schedule-notice__yellow' );
		}

		scheduleOptions.append( scheduleDesc );

		scheduleFields.append( this.createScheduleDateHTML() );

		scheduleFields.append( this.createScheduleTimeHTML() );

		scheduleOptions.append( scheduleFields );

		scheduleOptions.append( this.createTimeZone() );

		scheduleOptions.append( this.scheduleNoticeHTML );

		return scheduleOptions;
	}

	createDelayOptions() {
		const delayOptions = $( `<div/>`, { class: 'delay-options' } );

		const delayDesc = $( '<span/>', { class: 'async-mode__description' } ).text(
			UncannyAutomator.i18n.action.asyncActions.modal.delayDesc
		);

		const delayFields = $( '<div/>', { class: 'delay-fields' } );

		this.delayNumberHTML = this.createDelayNumberHTML();

		this.delayUnitHTML = this.createDelayUnitHTML();

		const delayFieldsDesc = $( '<span/>', { class: 'delay-fields__description' } ).text(
			UncannyAutomator.i18n.action.asyncActions.modal.after
		);

		delayFields.append( this.delayNumberHTML );

		delayFields.append( this.delayUnitHTML );

		delayFields.append( delayFieldsDesc );

		delayOptions.append( delayDesc );

		delayOptions.append( delayFields );

		return delayOptions;
	}

	createDelayNumberHTML() {
		this.delayNumberField = new Field(
			'int',
			{
				itemType: 'action',
				optionCode: 'delay-number',
				isRequired: true,
				placeholder: '10',
				supportsTokens: false,
				currentValue: this.item.meta.async_delay_number ? this.item.meta.async_delay_number : '',
			},
			true,
			this.validateDelayNumber
		);

		// Create form element
		const $delayNumberField = this.delayNumberField.createFormElement();

		$delayNumberField.addClass( 'delay-fields__number' );

		// Init Codemirror
		this.delayNumberField.initCodeMirror();

		return $delayNumberField;
	}

	createDelayUnitHTML() {
		this.delayUnitField = new Field( 'select', {
			itemType: 'action',
			optionCode: 'delay-unit',
			currentValue: this.item.meta.async_delay_unit ? this.item.meta.async_delay_unit : 'minutes',
			customClass: 'hide-this',
			supportsCustomValue: false,
			optionsShowID: false,
			isRequired: true,
			options: [
				{
					value: 'seconds',
					text: UncannyAutomator.i18n.action.asyncActions.modal.seconds,
				},
				{
					value: 'minutes',
					text: UncannyAutomator.i18n.action.asyncActions.modal.minutes,
				},
				{
					value: 'hours',
					text: UncannyAutomator.i18n.action.asyncActions.modal.hours,
				},
				{
					value: 'days',
					text: UncannyAutomator.i18n.action.asyncActions.modal.days,
				},
				{
					value: 'years',
					text: UncannyAutomator.i18n.action.asyncActions.modal.years,
				},
			],
		} );

		return this.delayUnitField.createFormElement().addClass( 'delay-fields__unit' );
	}

	createScheduleDateHTML() {
		// Create value field
		this.scheduleDateField = new Field( 'date', {
			itemType: 'action',
			optionCode: 'schedule-date',
			isRequired: true,
			placeholder: UncannyAutomator.i18n.action.asyncActions.modal.today,
			supportsTokens: false,
			currentValue: this.item.meta.async_schedule_date ? this.item.meta.async_schedule_date : '',
			placeholder: UncannyAutomator.i18n.format.date.selectDate,
		} );

		// Create form element
		const $scheduleDateField = this.scheduleDateField.createFormElement();

		$scheduleDateField.addClass( 'schedule-fields__date' );

		// Init Codemirror
		this.scheduleDateField.initFlatpickr();
		this.scheduleDateField.initCodeMirror();

		return $scheduleDateField;
	}

	createScheduleTimeHTML() {
		// Create value field
		this.scheduleTimeField = new Field( 'time', {
			itemType: 'action',
			optionCode: 'schedule-time',
			isRequired: true,
			supportsTokens: false,
			currentValue: this.item.meta.async_schedule_time ? this.item.meta.async_schedule_time : '',
			placeholder: UncannyAutomator.i18n.format.date.selectTime,
		} );

		// Create form element
		const $scheduleTimeField = this.scheduleTimeField.createFormElement();

		$scheduleTimeField.addClass( 'schedule-fields__time' );

		// Init Codemirror
		this.scheduleTimeField.initFlatpickr();
		this.scheduleTimeField.initCodeMirror();

		return $scheduleTimeField;
	}

	validateForm() {
		const asyncMode = this.asyncModeField.getValue();

		let validSchedule;

		switch ( asyncMode ) {
			case 'schedule':
				validSchedule = this.validateScheduleFields();
				break;
			case 'delay':
				validSchedule = this.delayNumberField.validate();
				break;
			default:
				validSchedule = {
					isValid: false,
					message: UncannyAutomator.i18n.action.asyncActions.modal.validation.unsupported,
				};
				break;
		}

		if ( ! validSchedule.isValid ) {
			return validSchedule;
		}

		return { isValid: true };
	}

	validateScheduleFields() {
		let validSchedule = this.scheduleDateField.validate();

		if ( validSchedule.isValid ) {
			validSchedule = this.scheduleTimeField.validate();
		}

		return validSchedule;
	}

	validateDelayNumber( value, simulate_int ) {
		if ( value < 1 ) {
			return {
				isValid: false,
				message: UncannyAutomator.i18n.action.asyncActions.modal.validation.positiveNumber,
			};
		}

		return { isValid: true };
	}

	shouldAddButton() {
		return (
			// Check if it's an action
			this.itemType == 'action' &&
			// The action is not missing
			! this.item.isMissing
		);
	}
}

export default ItemHeaderAsync;
